import React, {useEffect, useState} from "react";
import {Head, Loading} from "../../components";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";


const Reward = () => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        handleGetData()
    } ,[])


    const handleGetData = () => {
        setLoading(true);

        let obj = {
            "form": "deposit_index",
            "period_id": 81
        }

        new Api().get(`/marketers/deposits/list`,obj).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    setData(response.details.data)
                } else {
                    toast.error(response.msg);
                }

                setLoading(false);
            }
        })
    }

    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'پاداش بازاریابان', 'description': 'پاداش ها را مدیریت کنید' }} />
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>نام</th>
                        <th> نام خانوادگی</th>
                        <th>موبایل</th>
                        <th>مبلغ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <td>{data.marketer?.user?.name}</td>
                    <td>{data.marketer?.user?.family}</td>
                    <td>{data.marketer?.user?.mobile}</td>
                    <td>{data.amount}</td>
                    </tbody>
                </table>
            </div>

            {loading && <Loading/>}
        </div>
    );

}

export default Reward;